import React, { useState, useEffect } from "react";


const OSComparisonGame = () => {
  const initialFeatures = [
    { text: "Has a colorful start menu", os: "Windows" },
    { text: "Known for strong security and fewer viruses", os: "macOS" },
    { text: "Open-source and free to use", os: "Linux" },
    { text: "Compatible with most PC software", os: "Windows" },
    { text: "Runs only on Apple devices", os: "macOS" },
    { text: "Highly customizable desktop environment", os: "Linux" },
    { text: "Uses Finder to organize files", os: "macOS" },
    { text: "Popular for gaming", os: "Windows" },
    { text: "Terminal/Command Line is commonly used", os: "Linux" },
    { text: "Known for smooth animations and sleek design", os: "macOS" },
    { text: "Includes Microsoft Office easily", os: "Windows" },
    { text: "Requires licenses for most software", os: "Windows" },
    { text: "Supports many types of hardware", os: "Windows" },
    { text: "Strong developer community and learning resources", os: "Linux" },
    { text: "Popular in schools and offices", os: "Windows" }
  ];

  const [cards, setCards] = useState([]);
  const [draggedCard, setDraggedCard] = useState(null);
  const [placedCards, setPlacedCards] = useState({
    Windows: [],
    macOS: [],
    Linux: []
  });

  const shuffle = (array) => array.sort(() => Math.random() - 0.5);

  useEffect(() => {
    resetGame();
  }, []);

  const dragStart = (card) => setDraggedCard(card);

  const allowDrop = (e) => e.preventDefault();

  const dropCard = (os) => {
    if (!draggedCard) return;

    if (draggedCard.os === os) {
      setPlacedCards((prev) => ({
        ...prev,
        [os]: [...prev[os], draggedCard]
      }));
      setCards((prev) => prev.filter((c) => c.text !== draggedCard.text));
    } else {
      // flash incorrect
      setCards((prev) =>
        prev.map((c) =>
          c.text === draggedCard.text ? { ...c, incorrect: true } : c
        )
      );
      setTimeout(() => {
        setCards((prev) =>
          prev.map((c) =>
            c.text === draggedCard.text ? { ...c, incorrect: false } : c
          )
        );
      }, 500);
    }
    setDraggedCard(null);
  };

  const resetGame = () => {
    setCards(shuffle([...initialFeatures]).map((c) => ({ ...c, incorrect: false })));
    setPlacedCards({ Windows: [], macOS: [], Linux: [] });
  };

  // --- Inline Styles ---
  const styles = {
    body: { fontFamily: "'Comic Sans MS', cursive, sans-serif", background: "linear-gradient(to bottom, #fff5e6, #e6f7ff)", minHeight: "100vh", padding: 20 },
    h1: { textAlign: "center", color: "#ff6600", textShadow: "1px 1px #fff" },
    container: { display: "flex", justifyContent: "space-around", flexWrap: "wrap", marginTop: 20, gap: 20 },
    osColumn: { width: 250, background: "#ffffff", border: "3px solid #ffb84d", borderRadius: 12, padding: 10, boxShadow: "3px 3px 10px rgba(0,0,0,0.2)", textAlign: "center" },
    dropzone: { minHeight: 300, border: "2px dashed #ffcc80", borderRadius: 10, marginTop: 10, padding: 5, transition: "background 0.3s" },
    card: { background: "#ffd699", margin: 5, padding: 8, borderRadius: 8, cursor: "grab", boxShadow: "2px 2px 5px rgba(0,0,0,0.2)", transition: "transform 0.2s" },
    correct: { background: "#a0e6a0", transform: "scale(1.1)" },
    incorrect: { animation: "shake 0.5s", background: "#ff9999" },
    cardsContainer: { display: "flex", flexWrap: "wrap", justifyContent: "center", marginTop: 20, gap: 10 },
    resetBtn: { display: "block", margin: "20px auto", padding: "8px 15px", background: "#ff6600", color: "white", border: "none", borderRadius: 8, fontSize: 16, cursor: "pointer", boxShadow: "2px 2px 5px rgba(0,0,0,0.3)" }
  };

  return (
    <div style={styles.body}>
      <h3 style={styles.h1}>🖥️ OS Comparison Sorting Game</h3>

      <div style={styles.container}>
        {["Windows", "macOS", "Linux"].map((os) => (
          <div key={os} style={styles.osColumn}>
            <h5 style={{ color: "#ff6600", margin: 0 }}>{os}</h5>
            <div
              style={styles.dropzone}
              onDragOver={allowDrop}
              onDrop={() => dropCard(os)}
            >
              {placedCards[os].map((card) => (
                <div key={card.text} style={{ ...styles.card, ...styles.correct }}>{card.text}</div>
              ))}
            </div>
          </div>
        ))}
      </div>

      <h4 style={{ textAlign: "center", marginTop: 30 }}>Drag these features to the correct OS:</h4>
      <div style={styles.cardsContainer}>
        {cards.map((card) => (
          <div
            key={card.text}
            draggable
            onDragStart={() => dragStart(card)}
            style={{ ...styles.card, ...(card.incorrect ? styles.incorrect : {}) }}
          >
            {card.text}
          </div>
        ))}
      </div>

      <button style={styles.resetBtn} onClick={resetGame}>Reset Game</button>

      {/* Keyframes for shake */}
      <style>
        {`
          @keyframes shake {
            0% { transform: translateX(0px);}
            25% { transform: translateX(-5px);}
            50% { transform: translateX(5px);}
            75% { transform: translateX(-5px);}
            100% { transform: translateX(0px);}
          }
        `}
      </style>
    </div>
  );
};

export default OSComparisonGame;
